<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-additional-prompts-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Suggested prompts</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body additional-prompts-body">
        <div class="additional-prompts-mode" role="group" aria-label="Prompt type">
          <button
            *ngFor="let promptSet of promptSetOptions; trackBy: trackByPromptSet"
            class="additional-prompts-mode-option"
            [class.additional-prompts-mode-option-active]="selectedPromptSet === promptSet.value"
            type="button"
            (click)="selectPromptSet(promptSet.value, $event)"
          >
            {{ promptSet.label }}
          </button>
        </div>

        <div class="additional-prompts-toolbar">
          <div class="additional-prompts-categories" role="group" aria-label="Prompt categories">
            <button
              *ngFor="let category of categoryOptions; trackBy: trackByCategory"
              class="additional-prompts-category-filter"
              [class.additional-prompts-category-filter-active]="selectedCategory === category.label"
              type="button"
              (click)="selectCategory(category.label, $event)"
            >
              <span>{{ category.label }}</span>
              <span class="additional-prompts-category-count">{{ category.count }}</span>
            </button>
          </div>

          <label class="additional-prompts-language">
            <span>Language</span>
            <ng-select
              class="additional-prompts-language-select"
              [items]="languageOptions"
              bindLabel="label"
              bindValue="value"
              [searchable]="false"
              [clearable]="false"
              [ngModel]="selectedLanguage"
              (ngModelChange)="selectedLanguage = $event">
              <ng-template ng-label-tmp let-item="item">
                <span class="additional-prompts-language-option">
                  <span *ngIf="item.code" [ngClass]="'fi fi-' + item.code.toLowerCase()"></span>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="additional-prompts-language-option">
                  <span *ngIf="item.code" [ngClass]="'fi fi-' + item.code.toLowerCase()"></span>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>
            </ng-select>
          </label>
        </div>

        <div class="additional-prompts-groups">
          <div *ngFor="let group of promptGroups; trackBy: trackByGroup" class="additional-prompts-group">
            <div class="additional-prompts-group-title">
              <span>{{ group.category }}</span>
              <span>{{ group.prompts.length }}</span>
            </div>

            <div class="additional-prompts-list">
              <button
                *ngFor="let prompt of group.prompts; trackBy: trackByPrompt"
                class="additional-prompt"
                type="button"
                (click)="selectPrompt(prompt, $event)"
              >
                <span class="additional-prompt-text">{{ getPromptText(prompt) }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
